/* Responsive FAQs and configurable product links. */
(() => {
  if (window.zooFaqInitialized) return;
  window.zooFaqInitialized = true;
  const instances = new WeakMap();
  function initialize(section) {
    if (instances.has(section)) return;
    const mobile = window.matchMedia('(max-width: 767px)');
    const items = Array.from(section.querySelectorAll('.faq-item'));
    function layout() {
      items.forEach((item, index) => {
        item.open = mobile.matches || index === 0;
        const summary = item.querySelector('summary');
        summary.tabIndex = mobile.matches ? -1 : 0;
        if (mobile.matches) summary.setAttribute('aria-disabled', 'true');
        else summary.removeAttribute('aria-disabled');
      });
    }
    items.forEach(item => {
      item.querySelector('summary').addEventListener('click', event => { if (mobile.matches) event.preventDefault(); });
      item.addEventListener('toggle', () => {
        if (mobile.matches || !item.open) return;
        items.forEach(other => { if (other !== item) other.open = false; });
      });
    });
    mobile.addEventListener('change', layout);
    instances.set(section, () => { mobile.removeEventListener('change', layout); instances.delete(section); });
    layout();
  }
  function mount(container) {
    const config = window.zooCarouselConfig || {};
    for (const [selector, key] of [['[data-full-size-link]', 'fullSizeUrl'], ['[data-amazon-link]', 'amazonUrl']]) {
      container.querySelectorAll(selector).forEach(link => {
        if (link.hasAttribute('href')) return;
        const value = config[key]?.trim();
        if (!value) return;
        try {
          const url = new URL(value, window.location.href);
          if (!['http:', 'https:'].includes(url.protocol) && !value.startsWith('/products/')) return;
          link.setAttribute('href', value);
          link.removeAttribute('aria-disabled');
        } catch { /* Keep missing or invalid URLs disabled. */ }
      });
    }
    container.querySelectorAll('.product-faq').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.product-faq').forEach(section => instances.get(section)?.());
  });
})();
